
export enum ApplicationTokens {
    JMS = 'JMS',
    ID = 'ID',
    Console = 'Console',
    Compliance = 'Compliance',
    JmsWorker = 'ActivityWorker',
    PdfWorker = 'PDF',
    Portal = 'Portal',
    GlobalWorker = 'GlobalWorker',

    Functions = 'Functions',
    FunctionZip = 'FunctionZip',
    FunctionCopyBlob = 'FunctionCopyBlob',

    MicroservicePricing = 'Pricing',
    MicroserviceConnect = 'Connect',
    MicroserviceSideEffects = 'SideEffects',
    MicroserviceNatsCallout = 'NatsCallout',
    MicroserviceWalCoordinator = 'WalCoordinator',

    CustomisationAssett = 'CustomisationAssett',
    CustomisationBgis = 'CustomisationBgis',
}

export const TenantApps: readonly ApplicationTokens[] = [
    ApplicationTokens.JMS,
    ApplicationTokens.MicroserviceConnect,
    ApplicationTokens.MicroserviceSideEffects,
    ApplicationTokens.CustomisationAssett,
] as const;

export const TenantCustomisationApps: readonly ApplicationTokens[] = [
    ApplicationTokens.CustomisationAssett,
] as const;

export const RelayTargetApps: Readonly<Record<'tenantApps' | 'customisations', readonly ApplicationTokens[]>> = {
    tenantApps: TenantApps,
    customisations: TenantCustomisationApps,
} as const;
